import { Container, Row, Col } from 'react-bootstrap';
import python from '../assets/img/python.webp';
import golang from '../assets/img/golang.webp';
import keras from '../assets/img/keras.webp';
import javascript from '../assets/img/javascript.webp';
import svelte from '../assets/img/svelte.svg';
import vue from '../assets/img/vue.webp';
import react from '../assets/img/react.webp';
import html5 from '../assets/img/html5.webp';
import css from '../assets/img/css.webp';
import docker from '../assets/img/docker.webp';
import bash from '../assets/img/bash.webp';
import appScript from '../assets/img/appScript.webp';
import TrackVisibility from 'react-on-screen';
import 'animate.css';





export const Languages = ({ onLoad }) => {
    const lenguages_list = [{name: "Python", icon: python}, {name: "Golang", icon: golang}, {name: "Keras", icon: keras}, {name: "Javascript", icon: javascript}, {name: "Vue", icon: vue},{name: "Svelte", icon: svelte}, {name: "React", icon: react}, {name: "HTML5", icon: html5}, {name: "CSS", icon: css}, {name: "Docker", icon: docker}, {name: "Bash", icon: bash}, {name: "AppScript", icon: appScript}]
      
    return (
        <section className="languages" id="languages">
            <Container>
                <Row className="align-items-center">
                    <Col>
                        <div className="languages-bx">
                            <h2>Tecnologías</h2>
                            <p>Estas son las principales tecnologías que utilizo en este momento.</p>
                            <div className="languages-list">
                                {lenguages_list.map((lenguage, index) => (
                                    <TrackVisibility key={index}>
                                    { ({ isVisible }) =>
                                        <div className={isVisible ? "animate__bounceIn animate__delay-2s languages-item" : "languages-item"}>
                                            <img onLoad={ onLoad } src={lenguage.icon} alt="{lenguage.icon}" id={lenguage.name==="Javascript" ? "javascipt-icon" : ""}></img>
                                            <h5>{lenguage.name}</h5>
                                        </div>
                                    }
                                    </TrackVisibility>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}